import React from 'react';
import DsLabel from '../label';

const ErrorScreen = ({ children, title }) => (
        <div>
          <h1>
            <DsLabel
                    icon="cross"
                    className="text-xl uppercase"
                    iconClassName="text-xl text-status-red  font-bold"
            >
              {title}
            </DsLabel>
          </h1>
          {children && <div className="text-base">
            {children}
          </div>}
        </div>
);

export default ErrorScreen;
